<template>
  <el-dialog
    ref="dialog"
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    class="data_list_dialog"
    width="1200px"
    :before-close="modalClose"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @open="handleOpen('dialog')"
  >
    <div class="container-box">
      <!-- 查询条件 -->
      <div
        ref="searchCondition"
        class="search-condition"
      >
        <el-row :gutter="10">
          <el-col style="width:60px;padding-left:10px;">
            <el-button
              type="text"
              style=""
            >
              查询条件：
            </el-button>
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.schemeNo"
              placeholder="请输入方案编号"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="4">
            <el-input
              v-model="tableList.tableQuery.search.userName"
              placeholder="请输入人员名称"
              style="width:100%"
              clearable
              @keyup.enter.native="loadTableData"
            />
          </el-col>
          <el-col :span="5">
            <el-button
              type="primary"
              @click="searchData(tableList)"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <div class="table-wrap table-list-show">
        <custom-table
          :ref="tableList.tableKey"
          :table-key="tableList.tableKey"
          :data-obj="tableList"
          :table-columns="tableList.tableColumns"
          :table-data="tableList.tableData"
          :loading="tableList.tableLoading"
          :search-condition.sync="tableList.tableQuery"
          :table-custom-height="tableHeight"
          :is-paging="isPaging"
          is-index-field
          :data-total="tableList.tableDataTotal"
          :table-contextmenu="tableList.tableContextmenu"
          @reloadData="loadTableData(tableList)"
          @signInBill="signInBillFun(arguments)"
          @signOutBill="signOutBillFun(arguments)"
        />
      </div>
      <!-- 新增 修改-->
      <add-edit-view-dialog
        :event-type="'edit'"
        :data-id="id"
        :in-out-type="inOutType"
        :operate-type="operateType"
        :dialog-title="dialogAddEditTitle"
        :dialog-visible.sync="dialogAddEditVisible"
        :master-table-key="tableList.tableKey"
        @reloadData="reloadMasterData()"
      />
    </div>
  </el-dialog>
</template>
<script>
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 计算表格高度，搜索，获取数据Mixin
import dialogTableCustomMixin from '@/mixin/dialogTableCustomMixin'
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 新增 修改
import AddEditViewDialog from './addEditViewDialog'
import { loadActivitySignInOutInfoListDataApi } from '@/api/activitySignInOutInfo'
export default {
  name: 'ActivitySignInOutInfoTaskList',
  components: { CustomTable, AddEditViewDialog },
  mixins: [dialogDragMixin, dialogTableCustomMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    taskType: {
      type: Number,
      default: 0
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      customerName: '',
      tableList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'activity_sign_in_out_info_list', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            prop: 'signIn',
            label: '补签签到',
            method: 'signInBill'
          },
          {
            prop: 'signOut',
            label: '补签签退',
            method: 'signOutBill'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          sort: { // 排序对象
            prop: '', // 排序字段
            order: '' // 排序类型 ascending升序 descending降序
          },
          search: {
            userName: '',
            schemeNo: ''
          }
        }
      },
      isPaging: true,
      dialogAddEditTitle: '',
      dialogAddEditVisible: false,
      id: null,
      // 操作类型 1补签 2改签
      operateType: null,
      //操作类型 1签到 2签退
      inOutType: null
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        if(this.taskType === 1){
          this.tableList.tableContextmenu[0].label = '补签签到'
          this.tableList.tableContextmenu[1].label = '补签签退'
          this.tableList.tableQuery.search.isRepair = 1
          this.tableList.tableQuery.search.isChange = null
        } else {
          this.tableList.tableContextmenu[0].label = '改签签到'
          this.tableList.tableContextmenu[1].label = '改签签退'
          this.tableList.tableQuery.search.isRepair = null
          this.tableList.tableQuery.search.isChange = 1
        }
        this.operateType = this.taskType
        this.tableList.initTableColumn = [
          { prop: 'validateWarning', filterColumn: 'i.validate_warning', label: '预警信息', width: 220 },
          { prop: 'provinceName', filterColumn: 's.province_names', label: '省区名称', width: 120 },
          { prop: 'cityName', filterColumn: 's.city_names', label: '城市名称', width: 120 },
          { prop: 'schemeName', filterColumn: 's.name', label: '方案名称', width: 220 },
          { prop: 'schemeNo', filterColumn: 's.project_no', label: '方案编号', width: 220 },
          { prop: 'sortStr', filterColumn: 'i.sort', filterValue: 'sort', label: '类型', width: 120, filterArray: [{ label: '活动报告', value: 1 }, { label: '工作日志', value: 2 }] },
          { prop: 'sellId', filterColumn: 'i.sell_id', label: '报告编号', width: 120 },
          { prop: 'logId', filterColumn: 'i.log_id', label: '日志编号', width: 120 },
          { prop: 'storeName', filterColumn: 'i.store_name', label: '活动场所', width: 120 },
          { prop: 'userName', filterColumn: 'i.user_name', label: '人员名称', width: 120 },
          { prop: 'activityDateStr', filterColumn: 'i.activity_date', label: '工作日期', width: 140, isBetween: true },
          { prop: 'activityTimeStr', label: '工作时间段', filterColumn: '(case activity_time when \'1,2\' then \'上午,下午\' when \'1,3\' then \'上午,晚上\' when \'2,3\' then \'下午,晚上\' when 1 then \'上午\' when 2 then \'下午\' when 3 then \'晚上\' else \'\' end)', width: 120 },
          { prop: 'fieldTypeStr', filterColumn: 'i.field_type', filterValue: 'fieldType', label: '活动场次', width: 120, filterArray: [{ label: '一场半天', value: 1 }, { label: '一场一天', value: 2 }] },
          { prop: 'isSignInStr', filterColumn: 'i.is_sign_in', filterValue: 'isSignIn', label: '是否签到', width: 120, filterArray: [{ label: '是', value: 1 }, { label: '否', value: 0 }] },
          { prop: 'signInTimeStr', filterColumn: 'i.sign_in_time', label: '签到时间', width: 160 },
          { prop: 'signInAddress', filterColumn: 'i.sign_in_address', label: '签到地点', width: 160 },
          { prop: 'isSignOutStr', filterColumn: 'i.is_sign_out', filterValue: 'isSignIn', label: '是否签退', width: 120, filterArray: [{ label: '是', value: 1 }, { label: '否', value: 0 }] },
          { prop: 'signOutTimeStr', filterColumn: 'i.sign_out_time', label: '签退时间', width: 160 },
          { prop: 'signOutAddress', filterColumn: 'i.sign_out_address', label: '签退地点', width: 160 },
          { prop: 'minuteDifference', filterColumn: 'i.minute_difference', label: '分钟时差', width: 120 },
          { prop: 'hourDifference', filterColumn: 'i.hour_difference', label: '小时时差', width: 120 },
          { prop: 'remark', filterColumn: 'i.remark', label: '备注' }
        ]
        this.tableList.tableColumns = this.tableList.initTableColumn
        this.searchData(this.tableList)
      }
    }
  },
  methods: {
    // 请求数据
    requestData () {
      this.tableList.tableLoading = true
      let pageCondition = { condition: JSON.stringify(this.tableList.tableQuery) }
      loadActivitySignInOutInfoListDataApi(pageCondition).then(response => {
        this.tableList.tableLoading = false
        let data = response.data.data ? response.data.data : []
        this.handleData(this.tableList, data)
        this.tableList.tableDataTotal = response.data.recordsTotal
      }).catch()
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
    },
    // 刷新列表
    reloadMasterData () {
      this.$emit('reloadData')
      this.loadTableData(this.tableList)
    },
    // 签到
    signInBillFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return false
      } if (this.taskType === 1 && args[0].isSignIn === 1){
        this.$message({
          message: '已存在签到，不能补签',
          type: 'warning'
        })
        return false
      } else {
        this.id = args[0].id
        this.inOutType = 1
        this.dialogAddEditTitle = '签到' + (this.taskType === 1 ? '补签' : '改签')
        this.dialogAddEditVisible = !this.dialogAddEditVisible
      }
    },
    // 签退
    signOutBillFun (args) {
      if (!args[0]) {
        this.$message({
          message: '请选择数据行',
          type: 'warning'
        })
        return false
      } if (this.taskType === 1 && args[0].isSignIn === 0){
        this.$message({
          message: '不存在签到，不能补签签退',
          type: 'warning'
        })
        return false
      } if (this.taskType === 1 && args[0].isSignOut === 1){
        this.$message({
          message: '已存在签退，不能补签',
          type: 'warning'
        })
        return false
      } else {
        this.id = args[0].id
        this.inOutType = 2
        this.dialogAddEditTitle = '签退' + (this.taskType === 1 ? '补签' : '改签')
        this.dialogAddEditVisible = !this.dialogAddEditVisible
      }
    },
  }
}
</script>
<style lang="scss"  scoped>
.table-wrap {
  margin-top: 5px;
}
</style>
